"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fuzzySearch = (needle, haystack) => {
    const haystackLen = haystack.length;
    const needleLen = needle.length;
    if (needleLen > haystackLen) {
        return false;
    }
    if (needleLen === haystackLen) {
        return needle === haystack;
    }
    /* eslint-disable no-restricted-syntax, no-labels, no-plusplus, no-continue */
    outer: for (let i = 0, j = 0; i < needleLen; i++) {
        const needleChar = needle.charCodeAt(i);
        while (j < haystackLen) {
            if (haystack.charCodeAt(j++) === needleChar) {
                continue outer;
            }
        }
        return false;
    }
    return true;
};
exports.default = fuzzySearch;
